'use strict'

jQuery(document).ready(function ($) {
  
    // Add Lenis Prevent to Mobile Menu
    $(document).on('click', '#mobile-menu-control-wrapper .menu-toggle', function() {
      if ( $('.mobile-menu-open').length > 0 ) {
        lenis.stop();
        $('#site-navigation').attr("data-lenis-prevent", "true");
      } else {
        lenis.start();
        $('#site-navigation').removeAttr("data-lenis-prevent");
      }
    });

    // Header Sticky 
    $(this).scrollTop(0)
    $(window).scroll(function () {
        if ($(this).scrollTop() > 1) {
            $('header.site-header').addClass("is-sticky");
        } else {
            $('header.site-header').removeClass("is-sticky");
        }
    });
    
    // check if site-header offset top is greater than 0
    if($('header.site-header').offset().top > 0) {
        $('header.site-header').addClass("is-sticky");
    }
  
    if($('.post-filter-outer').length > 0) {
        $(document).on('click','.post-filter-outer button', function() {
            $(this).closest('.post-filter-outer').find('button').removeClass('active')
            $(this).addClass('active')
            const filterValue = $(this).val()
            const filterValueCount = $(this).attr('data-cat-post-count')
            const postTotalCount = $(this).closest('.wp-block-group__inner-container').find('#load-more').attr('data-total')
            const postCount = $(this).closest('.wp-block-group__inner-container').find('#load-more').attr('data-count')
            const self = $(this)
            console.log(filterValueCount,postTotalCount);
            
            $.ajax({
                url: roam_obj.ajaxurl,  
                type: 'POST',  
                data: {    
                    action: 'filter_posts',    
                    "category-id": filterValue,
                    "count": postCount,
                },
            })
            .done(function(response) {
                $('.post-archive-outer').html(response)
                filterValueCount <= postCount ? $(self).closest('.wp-block-group__inner-container').find('#load-more').fadeOut() : $(self).closest('.wp-block-group__inner-container').find('#load-more').fadeIn()   
            })
            .fail(function(jqXHR, textStatus, errorThrown) {
                console.log('Request failed:', textStatus, errorThrown);
            })
            .always(function() {
                console.log('AJAX request finished');
            });
            
        })

        $(document).on('click','#load-more',function() {
            const postCount = $(this).attr('data-count')
            const postTotalCount = $(this).attr('data-total')
            const filterValue = $(this).closest('.post-filter-outer').find('button.active').val()
            const filterValueCount = $(this).closest('.post-filter-outer').find('button.active').attr('data-cat-post-count')
            const self = $(this)
            $.ajax({
                url: roam_obj.ajaxurl,  
                type: 'POST',  
                data: {    
                    action: 'filter_posts',    
                    "category-id": filterValue,
                    "count": Number(postCount) + 5
                },
            })
            .done(function(response) {            
                $('.post-archive-outer').html(response)
                $('#load-more').attr('data-count', Number(postCount) + 4, filterValueCount)
                postTotalCount <= Number(postCount) + 4 || filterValueCount <= Number(postCount) + 4 ? $(self).fadeOut() : $(self).fadeIn()
            })
            .fail(function(jqXHR, textStatus, errorThrown) {
                console.log('Request failed:', textStatus, errorThrown);
            })
            .always(function() {
                console.log('AJAX request finished');
            });
        })
    }

})